import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as filterActions from '../actions';
import Header from '../components/Header';
import GriddleRP from '../components/GriddleRP';
import { mobileDetect } from 'rp-gui-guide';
import Filter from '../containers/Filter';
import MostFeatured from '../containers/MostFeatured';

import Button from '../components/Button';
import Collapse from '../components/Collapse';
import Svg from 'rp-react-svg-icon';

class App extends PureComponent {

    constructor(props) {
        super(props);
        this.props.fetchMostFeatured();
    }

    render() {
        const { isFetching, requestFailed, data, isFetchingMostFeatured } = this.props.stallion;

        let mobileType;
        if (mobileDetect.mobile()) {
            mobileType = 'mobile';

            if (mobileDetect.tablet()) {
                mobileType = 'tablet';
            }
        }

        const transformedData = data.map((item) =>
            item.sire_line_style_name && item.sire_style_name
                ? item
                : Object.assign({}, item, {
                    sire_line_style_name: item.sire_line_style_name || '—',
                    sire_style_name: item.sire_style_name || '—',
                })
        );

        const toggleMobilePopover = () => {
            this.props.setFilterPopoverVisibility(!this.props.isFilterVisible);
        };

        const MobileFilterButton = () => (
            <Button
                className={`ui-btn ui-btn_large col-md-12 col-sm-12 ui-btn_secondary btn_filter${this.props.isFilterVisible ? '__active' : ''}`}
                onClick={toggleMobilePopover}
            >
                <Svg iconName={"filter"} className={"icon_filter"} />
                <span
                    className={"title"}
                >
                    Filter Stallions
                </span>
            </Button>
        );

        return (
            <div className="no-padding ">
                <Header mobileType={mobileType} />
                <div className="rn-canvas">
                    <div className="container ">
                        {!this.props.mostFeaturedRequestFailed && !this.props.isFetchingMostFeatured && <section className="sb-filter__most_featured">
                            <MostFeatured />
                        </section>}

                        <section className="sb-filter__heading_wrapper">
                            <h3 className="sb-filter__heading_wrapper_label">
                                Stallion Book
                            </h3>
                            <div className="button-container button-container__mobile-filter">
                                <MobileFilterButton />
                            </div>
                        </section>

                        <section
                            style={{
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'space-between',
                                alignItems: 'flex-start',
                            }}
                            className="sb-page-section row_nospace filter-collapse"
                        >
                            <div className={'filter-left'}>
                                    <Filter
                                        className={''}
                                        mobileType={mobileType}
                                        isOpen
                                    />
                                </div>

                                <Collapse
                                    useHeightCalcs={false}
                                    className={`ui-popover collapse collapse-wrapper${this.props.isAdvancedSectionExpanded ? '__expanded' : ''}
                                    `}
                                    isOpen={this.props.isFilterVisible}
                                >
                                    <Filter
                                        mobileType={mobileType}
                                        isOpen={this.props.isFilterVisible}
                                    />
                                </Collapse>
                            <div className="sb-results">
                                <GriddleRP
                                    isFetching={isFetching}
                                    results={transformedData}
                                    requestFailed={requestFailed}
                                />
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        );
    }
}

App.propTypes = {
    // Injected by React Redux
    stallion: PropTypes.object.isRequired,
    // Injected by React Router
    children: PropTypes.node,
    isFilterVisible: PropTypes.bool,
    isAdvancedSectionExpanded: PropTypes.bool,
    setFilterPopoverVisibility: PropTypes.func,
    setAdvancedSectionVisibility: PropTypes.func,
    fetchMostFeatured: PropTypes.func
};

function mapStateToProps(state) {
    return {
        stallion: state.stallion,
        isFilterVisible: state.filter.isFilterVisible,
        isAdvancedSectionExpanded: state.filter.isAdvancedSectionExpanded,
        mostFeaturedItems: state.stallion.mostFeaturedItems,
        isFetchingMostFeatured: state.stallion.isFetchingMostFeatured,
        mostFeaturedRequestFailed: state.stallion.mostFeaturedRequestFailed,
    };
}

export default connect(mapStateToProps, filterActions)(App);



// WEBPACK FOOTER //
// ./src/client/containers/App.js